export const Status = {
  Pending: 1,
  Approve: 2,
  Reject: 3,
  MemberPaymentVerificationPending: 5,
  MemberPaymentVerificationApprove: 6,
  MemberPaymentVerificationReject: 7,

  MemberRegistrationModule_Draft: 21,
  MemberRegistrationModule_PendingWithHRHOD: 22,
  MemberRegistrationModule_RejectedHRHOD: 23,
  MemberRegistrationModule_PendingWithMemberForPaymentDetails: 24,
  MemberRegistrationModule_PendingWithInternalTeam: 25,
  MemberRegistrationModule_RejectedByInternalTeam: 26,
  // MemberRegistrationModule_PendingWithAdmin: 25,
  // MemberRegistrationModule_RejectedByAdmin: 26,
  MemberRegistrationModule_PendingWithEnrollmentCommittee: 27,
  MemberRegistrationModule_MemberRequestApproved: 28,
  MemberRegistrationModule_MemberRequestRejected: 29,
};

export const loggedRoleStatus = {
  label : "Enrollment Committee",
  value : 4,
}


export const LoanTypeEnum = {
  SHORTTERM:159,
  LONGTERM:160,
  ADDITIONALLONGTERM:161
}

export const LoanTypeNames = {
  STL1 : "STL1",
  STL2 : "STL2",
  LTL : "LTL",
  ALTL1 : "ALTL1",
  ALTL2 : "ALTL2",
  ALTL3 : "ALTL3",
  ALTL4 : "ALTL4"
}

export const NomineeLimit = 3; 

export const GenericMasterType = {
  SHORTTERM:16,
  LONGTERM:15,
  ADDITIONALLONGTERM:0,
  LOANREPAYMENT:25
}

export const MODES = {
  VIEW:"VIEW",
  EDIT:"EDIT",
  DELETE:"DELETE"
}

export const URL_PARAMS = {
  NewMemberRegister : 1,
  SettledMemberRegister : 2,
  SuretyRegister : 3,
  LoanRegister : 4,
  LoanPaidInExcess : 5,
  MemberTableReco : 6,
  ShortRecoveryReport : 7,
  DividendCalculation : 8,
  DividendNEFTFile : 9,
  HDFCToHDFC : 10,
  DividendWarrantPrint : 11,
  ShareRegister : 12,
}

// Adjust this regex pattern to include any special characters you want to disallow
export const SPECIALCHARPATTERN = /[!@#$%^&*(),?"':{}|<>]/; 
export const STARTYEAR = 2000; 

export const MONTHSLIST = [
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" },
];